// Minimum eight characters, at least one uppercase letter, one lowercase letter and one number and special character
export const passwordRequirements = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!*()@%&]).{8,200}$/

export default value => !value ? null : value.length >= 8 ?
  undefined : 'Minimum eight characters'
